import store from '@/store';

export default async function checkIsUserAllowedToSeeModule (to) {

  if (store.getters['actingUser/getActingUserDetails'].navigation?.length === 0)
  {
    await store.dispatch['actingUser/refreshActingUserDetails'];
  }
    
  const moduleId = to?.meta?.moduleId;
  if (to.meta.ignoreModuleCheck) return true;
  if (moduleId != undefined) {
    return store.getters['actingUser/isUserAllowedToSeeModule'](moduleId);
  }
  return true;
}
